import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',
            lang: navigator.language || navigator.userLanguage
    };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        //console.log("wfwefwefF",this.state.lang )

        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​










            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div style={{margin:"auto"}}>


                <div style={{margin:"auto", width: "80%", display: "block", fontFamily:"Open Sans, sans-serif"}} >


                    {lang==="en" && <div style={{width: "100%",margin: "auto", maxWidth:"100%", verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <div style={{fontSize:"1.5em", fontWeight:"bold"}}>News</div>
<br/>

                        <div style={{fontSize:"1.25em", fontWeight:"bold"}}>The Morrow Firm’s Xinlin Morrow Selected to Super Lawyers Up-and-Coming 50: 2020 Women Southern California Rising Stars</div>
<br/>
                        <div style={{fontSize:".8em", fontWeight:"bold"}}> June 2020</div>
<br/>
                        <div style={{fontSize:".8em"}} > The Morrow Firm’s principal, Xinlin Li Morrow, has been named to the <a href="https://www.superlawyers.com/california-southern/toplists/up-and-coming-50-2020-women-southern-california-rising-stars/0ebcdb06cf4d039f0d08b356c26bc466">Super Lawyers Up-and-Coming 50: 2020 Women Southern California Rising Stars</a>.</div>
                        <br/>
                           <div style={{fontSize:".8em"}} >   Ms. Morrow has been selected to Southern California Super Lawyers “Rising Stars” list each year since 2015.</div>
                        <br/>
                           <div style={{fontSize:".8em"}} >  Super Lawyers is a rating service of outstanding lawyers from more than 70 practice areas who have attained a high-degree of peer recognition and professional achievement. The selection process includes independent research, peer nominations, and peer evaluations. To be eligible for inclusion in Rising Stars, a candidate must be either 40 years old or younger or in practice for 10 years or less. While up to five percent of the lawyers in the state are named to Super Lawyers, no more than 2.5 percent are named to the Rising Stars list.</div>
<br/>
<br/>
                           <div style={{fontSize:"1.25em", fontWeight:"bold"}}>The Morrow Firm’s Xinlin Morrow Elected to Los Angeles Intellectual Property Law Association’s (LAIPLA) Board of Directors</div>
<br/>
                        <div style={{fontSize:".8em", fontWeight:"bold"}}>June 2020</div>
<br/>
                        <div style={{fontSize:".8em"}} >The Morrow Firm’s principal, Xinlin Li Morrow, has been elected to the Board of Directors at the <a href="https://www.laipla.net/">Los Angeles Intellectual Property Law Association (LAIPLA)</a>.</div>
                        <br/>
                        <div style={{fontSize:".8em"}} >  Prior to being elected to the board, Ms. Morrow has chaired LAIPLA’s Judges’ Night and Law School Roadshow committees.</div>
                        <br/>
                                <div style={{fontSize:".8em"}} >    LAIPLA is one of the nation’s premier intellectual property law associations. Since 1934, LAIPLA has been educating and connecting members of the local intellectual property legal community.</div>
                    </div>}

                    {lang==="zh" && <div style={{width: "100%",margin: "auto", maxWidth:"100%", minWidth:"20em",verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <div style={{fontSize:"1.5em", fontWeight:"bold"}}>News</div>
                        <br/>
                        <br/>
                        <div style={{fontSize:"1em"}}>The Morrow Firm’s Xinlin Morrow Selected to Super Lawyers Up-and-Coming 50: 2020 Women Southern California Rising Stars</div>
                        <br/>
                        <div style={{fontSize:".8em", fontWeight:"bold"}}> June 2020</div>
                        <br/>
                        <div style={{fontSize:".8em"}} > The Morrow Firm’s principal, Xinlin Li Morrow, has been named to the <a href="https://www.superlawyers.com/california-southern/toplists/up-and-coming-50-2020-women-southern-california-rising-stars/0ebcdb06cf4d039f0d08b356c26bc466">Super Lawyers Up-and-Coming 50: 2020 Women Southern California Rising Stars</a>.</div>
                            <div style={{fontSize:".8em"}} >   Ms. Morrow has been selected to Southern California Super Lawyers “Rising Stars” list each year since 2015.</div>
                        <div style={{fontSize:".8em"}} >   Super Lawyers is a rating service of outstanding lawyers from more than 70 practice areas who have attained a high-degree of peer recognition and professional achievement. The selection process includes independent research, peer nominations, and peer evaluations. To be eligible for inclusion in Rising Stars, a candidate must be either 40 years old or younger or in practice for 10 years or less. While up to five percent of the lawyers in the state are named to Super Lawyers, no more than 2.5 percent are named to the Rising Stars list.</div>
                        <br/>
                        <br/>
                        <div style={{fontSize:"1em"}}>The Morrow Firm’s Xinlin Morrow Elected to Los Angeles Intellectual Property Law Association’s (LAIPLA) Board of Directors</div>
                        <br/>
                        <div style={{fontSize:".8em", fontWeight:"bold"}}>June 2020</div>
                        <br/>
                        <div style={{fontSize:".8em"}} >The Morrow Firm’s principal, Xinlin Li Morrow, has been elected to the Board of Directors at the <a href="https://www.laipla.net/">Los Angeles Intellectual Property Law Association (LAIPLA)</a>.</div>
                        <div style={{fontSize:".8em"}} >   Prior to being elected to the board, Ms. Morrow has chaired LAIPLA’s Judges’ Night and Law School Roadshow committees.</div>
                        <div style={{fontSize:".8em"}} >   LAIPLA is one of the nation’s premier intellectual property law associations. Since 1934, LAIPLA has been educating and connecting members of the local intellectual property legal community.</div>
                    </div>}



                </div>


            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, { getUser})(contact);



// WEBPACK FOOTER //
// ./src/Containers/news.js